import React, { useState, useEffect } from 'react';
import { getPromptsForType } from './SuggestedPrompts';

// Utility to shuffle array and pick top n elements
const getRandomPrompts = (prompts, count) => {
  const shuffled = [...prompts].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

const FloatingPrompts = ({ onSelectPrompt, isSending, chatbotType, visible }) => {
  const [prompts, setPrompts] = useState([]);

  useEffect(() => {
    const allPrompts = getPromptsForType(chatbotType);
    const selectedPrompts = getRandomPrompts(allPrompts, 4); // Only select 4 random prompts
    setPrompts(selectedPrompts);
  }, [chatbotType]);

  if (!visible) return null;

  return (
    <div className="floating-prompts-container">
      {prompts.map((prompt, index) => (
        <button
          key={index}
          className="floating-prompt-button"
          onClick={() => onSelectPrompt(prompt)}
          disabled={isSending}
          style={{ 
            animationDelay: `${index * 0.15}s`,
            transform: `translateY(${index % 2 === 0 ? '-5px' : '5px'})` 
          }}
        >
          {prompt}
        </button>
      ))}
    </div>
  );
};

export default FloatingPrompts; 